

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import qs from 'qs';
@Component<VBANNER>({
  components: {
    dialogComp,
  },
})
export default class VBANNER extends Vue {
  public show() {
    (this.$refs.dialog as any).show();
  }
  public userName: string = '';
  public userPhone: string = '';
  public giftTip: string = '';
  public close() {
    (this.$refs.dialog as any).close();
    this.callback && this.callback();
  }
  public handleGet() {
    var reg = /^1[3456789]\d{9}$/gi;
    let dialog = this.$dialog as any;
    if (this.userName == '') {
      dialog.alert({
        message: '请输入姓名',
      });
    } else if (this.userPhone == '') {
      dialog.alert({
        message: '请输入手机号',
      });
    } else if (!reg.test(this.userPhone)) {
      dialog.alert({
        message: '请输入正确的手机号',
      });
    }
  }
  public callback() {}
}
